import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=0c935ac7&scoped=true&"
import script from "./addService.vue?vue&type=script&lang=js&"
export * from "./addService.vue?vue&type=script&lang=js&"
import style0 from "./addService.vue?vue&type=style&index=0&id=0c935ac7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c935ac7",
  null
  
)

export default component.exports